// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"51d81af79f566b8c93f1","655":"8da0ccba5a3edadea24d"}[chunkId] + ".js";
};